<template>
  <sf-dialog v-model="dialog">
    <template #activator="{ props }">
      <sf-edit-button
        id="pw-edit-default-approvers"
        v-bind="props"
        :aria-label="$t('orderLimits.editStandardApprovers')"
      />
    </template>
    <v-card>
      <v-card-item>
        <v-card-title>
          <sf-heading>{{ $t('orderLimits.defaultApprovers') }}</sf-heading>
        </v-card-title>
      </v-card-item>
      <v-card-text>
        <order-limit-approvers-select v-model="defaultApprovers" :approvers="approvers" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <sf-text-button color="grey" class="text-medium-emphasis" @click="closeDialog">
          {{ $t('cancel') }}
        </sf-text-button>
        <sf-text-button color="primary" @click="save">
          {{ $t('save') }}
        </sf-text-button>
      </v-card-actions>
    </v-card>
  </sf-dialog>
</template>

<script setup lang="ts">
import SfEditButton from '@/components/button/SfEditButton.vue'
import SfTextButton from '@/components/button/SfTextButton.vue'
import SfDialog from '@/components/dialog/SfDialog.vue'
import SfHeading from '@/components/text/SfHeading.vue'
import OrderLimitApproversSelect from '@/modules/orderLimits/components/OrderLimitApproversSelect.vue'
import useOrderLimits from '@/modules/orderLimits/useOrderLimits'
import MyCompanyEvent from '@/modules/tracking/events/MyCompany'
import { trackEvent } from '@/modules/tracking/useTracking'
import { ShortUser } from '@/types/index'
import { PropType, ref, watch } from 'vue'

const componentProps = defineProps({
  defaultApprovers: {
    type: Array as PropType<ShortUser[]>,
    required: true
  },
  approvers: {
    type: Array as PropType<ShortUser[]>,
    required: true
  }
})

const dialog = ref(false)
const defaultApprovers = ref(componentProps.defaultApprovers)

// set correct data when dialog is reopened
watch(dialog, (newValue) => {
  if (newValue === true) {
    defaultApprovers.value = componentProps.defaultApprovers
  }
})

const save = () => {
  useOrderLimits().updateDefaultOrderLimit({
    approverIds: defaultApprovers.value.map((approver) => approver.id)
  })
  trackEvent(MyCompanyEvent.OrderLimit.Default.Assignees)
  dialog.value = false
}

const closeDialog = () => {
  dialog.value = false
}
</script>
